import type { FaresRequestCopy } from '../fares/fares_request_page.js';
import { fmtWeekdayDayMonth } from '../results/flight_format.js';
import type { FlightFilterCopy } from '../results/filters/filter_copy.js';
import type { FlightExplorerPageCopy } from './explorer_copy.js';
import type { FlightFilterState } from '../results/filter_logic.js';
import type { FlightExplorerRequest } from './search_source.js';

/**
 * O PERFIL que a busca offline de voo envia à equipe VOLL — os chips do banner
 * e, tal-qual, o que o host anexa ao pedido (paridade com o legado, que
 * pré-preenchia o concierge pelos filtros: rota, datas, cabine, direto,
 * política — `ConciergeSubmissionInfo.fromFlightFilter`). Um chip por perna
 * ("GRU → SDU · qua, 24 set"), a volta do ida-e-volta, a cabine quando não é a
 * econômica, quantos viajam, e os cortes que descrevem o voo que a pessoa quer
 * (só direto, dentro da política, companhias). Horários e preço ficam de fora:
 * são cortes da LISTA em mão, não do pedido.
 */
export function flightOfflineProfile(
  request: FlightExplorerRequest,
  filter: Pick<FlightFilterState, 'stops' | 'withinPolicyOnly' | 'airlines'>,
  copy: {
    readonly page: FlightExplorerPageCopy;
    readonly request: FaresRequestCopy;
    readonly filter: FlightFilterCopy;
  },
  locale: string,
): string[] {
  const chips = request.legs.map(
    (leg) => `${leg.origin} → ${leg.destination} · ${fmtWeekdayDayMonth(leg.departDate, locale)}`,
  );
  if (request.mode === 'round_trip' && request.returnDate) {
    chips.push(copy.page.offlineReturnOn(fmtWeekdayDayMonth(request.returnDate, locale)));
  }
  if (request.cabin && request.cabin !== 'economy') {
    chips.push(copy.filter.cabin[request.cabin]);
  }
  if (request.travelerCount !== undefined && request.travelerCount > 0) {
    chips.push(copy.request.travelers(request.travelerCount));
  }
  if (filter.stops.length === 1 && filter.stops[0] === 'nonstop') {
    chips.push(copy.filter.stops.direct);
  }
  if (filter.withinPolicyOnly) chips.push(copy.filter.policy.withinPolicy);
  if (filter.airlines.length > 0) chips.push(filter.airlines.join(', '));
  return chips;
}
